/**
 * Loads every `./<lang>/<namespace>.ts`. Each file's default export is nested
 * under its file name, so `en/checkout.ts` exporting `{ title }` is read as
 * `t("checkout.title")`, and two files can never overwrite each other's keys.
 */
const modules = import.meta.glob("./*/*.ts", { eager: true });

type Messages = Record<string, unknown>;

const messages: Record<string, { translation: Messages }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (!match) return;
  const [, lang, namespace] = match;
  const module = modules[path] as { default?: Messages };
  if (!module.default) return;

  messages[lang] ??= { translation: {} };
  messages[lang].translation[namespace] = module.default;
});

export default messages;
